import { rpcSlice } from '../../../store/api/rpcSlice';

export interface LegacyAppIdentityCoverage {
  total_people: number;
  mapped_people: number;
  unmapped_people: number;
}

export interface TypeformLinkageQuality {
  total_submissions: number;
  direct_linked_person: number;
  resolved_by_email: number;
  unresolved: number;
}

export interface CapacitySheetResolution {
  total_rows: number;
  direct_legacy_id: number;
  coach_name_fallback: number;
  unresolved: number;
}

export interface IdentityResolutionReport {
  legacy_app_identity_coverage: LegacyAppIdentityCoverage;
  typeform_linkage_quality: TypeformLinkageQuality;
  capacity_sheet_resolution?: CapacitySheetResolution;
  capacity_sheet_resolution_error?: string;
}

export const identityResolutionApi = rpcSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIdentityResolutionReport: builder.query<IdentityResolutionReport, void>({
      query: () => ({
        url: '/admin/coach-matching/identity-resolution-report',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetIdentityResolutionReportQuery } = identityResolutionApi;
